export const AppPermissions = {
  view: {
    activePlayers: "patron360:dashboard:active-players",
    limitedPlayerInfo: "patron360:player:read:limited",
    playerInfo: "patron360:player:read",
    playerStats: "patron360:player:stats:read",
    notes: "patron360:notes:read",
    trips: "patron360:trips:read",
    hotel: "patron360:hotel:read",
    credit: "patron360:emarker:read",
    promotions: "patron360:promotions:read",
    events: "patron360:events:read",
    clubSerranoOnline: "patron360:club-serrano-online:read",
    mobile: "patron360:mobile:read",
    playerHostAudit: "patron360:player:host-audit",
    comps: "patron360:comps:read",
    offers: "patron360:offers:read",
    winloss: "patron360:winloss:read",
    sensitiveNotes: "patron360:notes:sensitive:read",
    netRevenue: "patron360:net-revenue:read",
    antiFraud: "patron360:dashboard:anti-fraud:read",
    favoritePlayers: "patron360:dashboard:favorite-players",
  },
  create: {
    notes: "patron360:notes:create",
    anyNote: "patron360:notes:create:any",
    sensitiveNotes: "patron360:notes:sensitive:create",
  },
  modify: {
    hotelBooking: "patron360:hotel:write",
    clubSerranoOnline: "patron360:club-serrano-online:write",
    notes: "patron360:notes:create",
    sensitiveNotes: "patron360:notes:sensitive:create",
    antiFraud: "patron360:dashboard:anti-fraud:write",
    favoritePlayers: "patron360:favorite-players:write",
  },
};
